import { DataProvider } from 'react-admin';
import Transformer from '../../common/Transformer';
import ApiResources from "src/providers/ApiResources";

import { Address } from './Address';

export const transform = (data, id) => {
    Transformer(data, {
        remove: [
            'id',
            'user',
            'createdAt',
            'updatedAt'
        ],
        update: {
            defaultBilling: data.default_billing.toString(),
            defaultShipping: data.default_shipping.toString(),
            user: id
        }
    });
    return data;
};

interface AddressFuctionProps {
    data: Address,
    previousData?: Address,
    dataProvider: DataProvider<string>,
    id: any
}

export function editAddress(props: AddressFuctionProps) {
    let {data, previousData, dataProvider, id} = props;

    return dataProvider.update(ApiResources.updateAddresses(false), {
        id: previousData.id, data: transform(data, id), previousData: previousData
    });
}

export function saveAddress(props: AddressFuctionProps) {
    let {data, dataProvider, id} = props;

    return dataProvider.create(ApiResources.postAddresses(false), { 
        data: transform(data, id) 
    });
}

export function deleteAddress(id: any, dataProvider: DataProvider<string>) {

    return dataProvider.delete(ApiResources.deleteAddresses(false), {
        id: id
    });
}